<app-progress-indicator [inProgress]="isLoading" [progressText]="'Lade Daten'"></app-progress-indicator>

<mat-tab-group *ngIf="!isLoading" [selectedIndex]="0" (selectedTabChange)="onTabChange($event)">
  <mat-tab *ngFor="let image of imageMap | keyvalue" [label]="image.key.toLocaleUpperCase()">
    <div class="wetter_content_container" style="text-align: center">
      <h3>Regenradar für Deutschland</h3>
      <button style="border-radius: 18px" mat-stroked-button (click)="reload()">
        <mat-icon color="primary">refresh</mat-icon>
        Erneut laden
      </button>

      <mat-horizontal-stepper [@.disabled]="true" labelPosition="bottom" [linear]="false"
                              #stepper="matHorizontalStepper">
        <ng-template matStepperIcon="edit">
          <mat-icon>map</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="done">
          <mat-icon>map</mat-icon>
        </ng-template>
        <ng-container *ngFor="let i of image?.value">
          <mat-step *ngIf="currentType === i.type && currentSize === i.size">
            <div class="regenradar-bild-container">
              <ng-template class="mat-step-header" matTooltip="{{i.zeitstempel}}"
                           matStepLabel>{{i.zeitstempel | date: 'HH:mm'}}</ng-template>
              <img [src]="i.imageUrl" alt="{{i.imageUrl}}">
            </div>
            <button mat-button matStepperPrevious>
              <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
            <button mat-button matStepperNext>
              <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
          </mat-step>
          <!--  Hier Dateiname noch -->
        </ng-container>
      </mat-horizontal-stepper>
      <div class="regenradar-size-container" id="regenradar-bild-nav">
                <span (click)="currentSize = size"
                      [class]="size === currentSize ? 'regenradar-bild-type-nav-label active' :'regenradar-bild-type-nav-label'"
                      id="regenradar-bild-type-nav-label_{{size}}"
                      *ngFor="let size of sizes">{{size.toUpperCase()}}</span>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>

